var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 3.33325V5.99992M7.3335 3.33325V5.99992",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 4.66675H9.33333C6.81917 4.66675 5.5621 4.66675 4.78105 5.44779C4 6.22885 4 7.48592 4 10.0001V11.3334C4 13.8475 4 15.1047 4.78105 15.8857C5.5621 16.6667 6.81917 16.6667 9.33333 16.6667H10.6667C13.1808 16.6667 14.4379 16.6667 15.2189 15.8857C16 15.1047 16 13.8475 16 11.3334V10.0001C16 7.48592 16 6.22885 15.2189 5.44779C14.4379 4.66675 13.1808 4.66675 10.6667 4.66675Z",
    stroke: "#64748B",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 8.33325H15.8332",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99716 11.3333H10.0032M9.99716 13.9999H10.0032M12.6608 11.3333H12.6668M7.3335 11.3333H7.33948M7.3335 13.9999H7.33948",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey);
export default __webpack_public_path__ + "static/media/calendar_grey.ee17c1d72c79395be91b045fa52a61d8.svg";
export { ForwardRef as ReactComponent };